module.exports = __webpack_public_path__ + "img/miryoku1.164acb23.jpg";